<p-dialog
  class="dialog-content-show-overflow"
  header="aaaa"
  [modal]="true"
  [visible]="visible()"
  #dialogEl>
  <ng-template #headless>
    <loader-wrapper
      [showBackgroundComponent]="true"
      [loaderKey]="loaderKey"
      class="[&>div:not(:first-child):last-child]:absolute">
      <div class="m-4 flex flex-col gap-5">
        <h1 class="text-base" i18n>Log out</h1>

        <div class="flex items-center gap-3">
          <ng-icon name="phosphorWarning" class="text-3xl"></ng-icon>

          <small i18n>Are you sure that you want to continue?</small>
        </div>

        <div class="flex justify-end gap-2">
          <p-button
            label="Cancel"
            severity="secondary"
            (click)="visible.set(false)" />
          <p-button label="Confirm" severity="danger" (click)="logout()" />
        </div>
      </div>
    </loader-wrapper>
  </ng-template>
</p-dialog>
